import { ForgotpasswordForm } from 'features/auth/components/forgot-password';
import darklogo from 'assets/images/bebrave-group-dark.svg';
import lightlogo from 'assets/images/bebrave-group.svg';
import { useTranslation } from 'react-i18next';
import { useTheme } from 'components/core/theme-provider';
import { useWhiteLabelStore } from 'state/store/white-label';

export function ForgotPasswordPage() {
  const { t } = useTranslation();
  const { theme } = useTheme();

  const { settings: whiteLabelSettings } = useWhiteLabelStore();

  // Determine which logo to use based on theme and white-label settings
  const logoSrc = theme === 'dark'
    ? (whiteLabelSettings?.logoUrlDarkMode || darklogo)
    : (whiteLabelSettings?.logoUrl || lightlogo);
  return (
    <div className="flex flex-col gap-6">
      <div className="w-32">
        <img src={logoSrc} className="w-full h-full object-contain" alt="logo" />
      </div>
      <div>
        <div className="text-2xl font-bold text-high-emphasis">{t('FORGOT_PASSWORD')}</div>
        <div className="flex gap-1 mt-1">
          <div className="text-sm font-normal text-medium-emphasis">
            {t('FORGOT_PASSWORD_DESCRIPTION')}
          </div>
        </div>
      </div>
      <ForgotpasswordForm />
    </div>
  );
}
